module.exports = __webpack_public_path__ + "static/media/webm-icon.648fa42b.svg";